var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowVertical = function SvgArrowVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.41 3.441A.405.405 0 0 1 0 3.023q-.001-.168.133-.308L2.707.137A.45.45 0 0 1 3.023 0c.118 0 .23.05.317.137l2.574 2.578q.134.14.133.308a.4.4 0 0 1-.406.418.44.44 0 0 1-.305-.125l-.887-.875L3.418 1.29l.031.844v4.851c0 .258-.172.434-.426.434-.25 0-.425-.176-.425-.434V2.133l.03-.848-1.03 1.156-.887.875a.43.43 0 0 1-.3.125"
  })));
};
export default SvgArrowVertical;